import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Spinner,
} from '@a-ui/react';
import qs from 'query-string';

import * as activateActions from '../actions/activation';
import * as cardActions from '../actions/card';

const CardActivate = () => {
  const { activation } = useSelector(state => ({
    activation: state.activation
  }));
  const [cardLoading, setCardLoading] = useState(false);
  const { card } = useSelector(state => ({
    card: state.card,
  }));

  const history = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const toUrl = qs.parse(location.search, { ignoreQueryPrefix: true }).fromUrl || '/overzicht';

  useEffect(() => {
    const cardNumber = sessionStorage.getItem('cardNumber') || undefined;
    dispatch(activateActions.activateCard(cardNumber));
  }, []);

  useEffect(() => {
    if (activation.error) {
      history('/', {
        state: {
          error: activation.error,
        },
      });
    }
  }, [activation.error]);

  if (activation.success) {
    if (!cardLoading) {
      setCardLoading(true);
      dispatch(cardActions.getCard({
        cardNumber: '',
        cardOwnership: 'me',
      }));
    }
  }

  if (card.fetched) {
    history(toUrl);
  }

  return (
    <div className="row ">
      <div className="col-md-6 col-md-offset-3 col-xs-12">
        <div className="box">
          <h5>
            Bezig met het activeren van de dienst sorteerstraatjes op uw A-kaart. Dit kan tot enkele minuten duren.
          </h5>
          <div className="u-margin-top">
            {activation.loading && <div className="center"><Spinner /></div>}
            {activation.error && (
              <div className="u-margin-bottom">
                <Alert theme="danger" inline>
                  <div dangerouslySetInnerHTML={{ __html: activation.error }} />
                </Alert>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardActivate;
